const getCircleBracketsContent = (str) => {
  const circleBracketsRexExp = /\(([^)]+)\)/;
  const matches = circleBracketsRexExp.exec(str);
  return matches && matches[1];
};

export default getCircleBracketsContent;
